import httpRequest from "@/api";
import { BaseService } from "@/api/baseService";
import type { ShipInfoServiceFeeQueryParams, ShipInfoServiceFeePayForm, ShipInfoServiceFee } from "@zhihaoscm/entity";
// 船务信息服务费
export class ShipInfoServiceFeeService extends BaseService<
    ShipInfoServiceFee,
    any,
    ShipInfoServiceFeeQueryParams,
    any
> {
    // 分页查询
    async pagging(params: ShipInfoServiceFeeQueryParams) {
        const { data } = await this.service.get(`${this.path}/custom-paging`, { params });
        return data;
    }
    // 查询详情
    async getDetail(id: string) {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }

    // 线下支付船务信息服务费 1货主 2船主
    async pay(form: ShipInfoServiceFeePayForm) {
        const { data } = await this.service.post(`${this.path}/pay`, form);
        return data;
    }
}

export const shipInfoServiceFeeService = new ShipInfoServiceFeeService("/ship-info-service-fee", httpRequest);
